export const minMax = (value) => {
    if(value === null || value === undefined) return [];
    const MinMax = value?.split('-');
    const isMinMax = MinMax?.length === 2
    if(isMinMax) return [MinMax[0], MinMax[1]];
    return [MinMax[0], MinMax[0]];
}